/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import { logSafeErrorWithoutCustomerDataWrapper } from '@jira/polaris__lib-logging/src/logSafeErrorWithoutCustomerDataWrapper.tsx';

export const logError = (errorSubject: string, error: Error): void => {
	const ERROR_ID = 'polaris-error';

	fireErrorAnalytics({
		meta: {
			id: ERROR_ID,
			teamName: 'polaris',
		},
		attributes: {
			subject: errorSubject,
		},
		error,
	});
	logSafeErrorWithoutCustomerDataWrapper(`${ERROR_ID}.${errorSubject}`, error.message, error);
};

export const isPendoReady = (): boolean =>
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	window?.pendo?.isReady && typeof window.pendo.isReady === 'function' && window.pendo.isReady();
